import React from 'react';

export function DiceRollerMockup() {
  return (
    <div className="landing-mockup-card text-center">
      <div className="flex justify-center gap-2 mb-3">
        {['d4', 'd6', 'd8', 'd10', 'd12', 'd20'].map((d) => (
          <div key={d} className="w-8 h-8 rounded-lg bg-muted/50 border border-border/30 flex items-center justify-center text-[10px] font-mono font-bold text-muted-foreground hover:text-primary hover:border-primary/30 transition-colors cursor-pointer">
            {d}
          </div>
        ))}
      </div>
      <div className="mb-3 p-3 rounded-lg bg-gradient-to-b from-primary/10 to-transparent border border-primary/20">
        <div className="text-[10px] text-muted-foreground mb-1">2d20kh1 + 5 (Avantage)</div>
        <div className="font-cinzel text-3xl font-black text-primary landing-dice-glow">
          NAT 20!
        </div>
        <div className="text-xs text-muted-foreground mt-1 font-mono">[20, 14] + 5 = 25</div>
      </div>
      <div className="flex gap-1 justify-center">
        {['Attaque', 'Fireball', 'Sneak'].map((p) => (
          <span key={p} className="text-[9px] px-2 py-0.5 rounded-full bg-muted/50 text-muted-foreground border border-border/30">{p}</span>
        ))}
      </div>
    </div>
  );
}
